import { ReactNode, useEffect } from 'react';
import { sepolia } from '@starknet-react/chains';
import {
  StarknetConfig,
  jsonRpcProvider,
  argent,
  braavos,
  useAccount,
} from '@starknet-react/core';
import { RPC_URL } from '@/lib/constants';
import { setWalletSigner } from '@/lib/api';

interface WalletProviderProps {
  children: ReactNode;
}

const connectors = [argent(), braavos()];

const provider = jsonRpcProvider({
  rpc: () => ({ nodeUrl: RPC_URL }),
});

/**
 * Syncs the connected wallet account to the API layer for request signing.
 */
function WalletSignerSync({ children }: { children: ReactNode }) {
  const { account } = useAccount();

  useEffect(() => {
    setWalletSigner(account ?? null);
    return () => setWalletSigner(null);
  }, [account]);

  return <>{children}</>;
}

export function WalletProvider({ children }: WalletProviderProps) {
  return (
    <StarknetConfig
      chains={[sepolia]}
      provider={provider}
      connectors={connectors}
    >
      <WalletSignerSync>{children}</WalletSignerSync>
    </StarknetConfig>
  );
}
